require("./aggregatorAddEntityNewModal.scss");

// @vendors
import React, { Fragment } from "react";
import PropTypes from "prop-types";

// @components
import { OKCheckbox } from "commonsComponents/OKCheckbox";
const OKModal = require("components/commons/OKModal/OKModal");
const ModalContent = require("../modalContent/modalContent");

// @utilities
const { FormattedText } = require('core/i18n').i18n;

// @constants
import {
    MAKE_OFFERS_CHECK_BOX,
    CHECK_BOX_CHECKED,
    THIRD_PARTIES_CHECK_BOX,
} from "constants/aggregator/aggregatorAddEntityModal.constants";

// @assets
const modalHeaderImg = require('assets/images/referrals-preview-logo.png');

class AggregatorAddEntityNewModal extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            [CHECK_BOX_CHECKED]: false,
            [MAKE_OFFERS_CHECK_BOX]: false,
            [THIRD_PARTIES_CHECK_BOX]: false,
        };
    }

    handleOnTermsChange = (checkableBox) => {
        this.setState((currState) => ({
            [checkableBox]: !currState[checkableBox],
        }));
    }

    render() {
        const {
            checkboxChecked,
            makeOffersCheckBox,
            thirdPartiesCheckBox,
        } = this.state;
        const { immAggregatorAddEntity, onRequestClose, showModal } = this.props;

        const contentFooter = !immAggregatorAddEntity.get(
            "termsAndConditionsError"
        ) ? (
            <Fragment>
                <div className="aggregator-add-entity-modal__checkbox">
                    <OKCheckbox
                        idName="aggregator-terms"
                        onChange={() =>
                            this.handleOnTermsChange(CHECK_BOX_CHECKED)
                        }
                        label={
                            <FormattedText value="aggregatorAddEntityModal-termsCheckbox" />
                        }
                        value={checkboxChecked}
                    />
                </div>
                <div className="aggregator-add-entity-modal__checkbox">
                    <OKCheckbox
                        idName="aggregator-make-offers"
                        onChange={() =>
                            this.handleOnTermsChange(MAKE_OFFERS_CHECK_BOX)
                        }
                        label={
                            <FormattedText value="aggregatorAddEntityModal-makeOffersCheckBox" />
                        }
                        value={makeOffersCheckBox}
                    />
                </div>
                <div className="aggregator-add-entity-modal__checkbox">
                    <OKCheckbox
                        idName="aggregator-third-parties"
                        onChange={() =>
                            this.handleOnTermsChange(THIRD_PARTIES_CHECK_BOX)
                        }
                        label={
                            <FormattedText value="aggregatorAddEntityModal-thirdPartiesCheckBox" />
                        }
                        value={thirdPartiesCheckBox}
                    />
                </div>
            </Fragment>
        ) : null;

        return (
            <OKModal
                content={<ModalContent hasError={immAggregatorAddEntity.get("termsAndConditionsError")}/>}
                contentFooter={contentFooter}
                respectModalContent={true}
                footerType="navigation"
                headerAlignment="left"
                headerContent={modalHeaderImg}
                isOpen={showModal}
                onCloseCallback={onRequestClose}
                onPrimaryButtonClick={() =>
                    this.props.onHandleTermsAndConditionsButton(this.state)
                }
                primaryButtonDisabled={!checkboxChecked}
                primaryButtonText="aggregatorAddEntityModal-acceptButton"
                primaryButtonLoading={immAggregatorAddEntity.get(
                    "termsAndConditionsFetch"
                )}
                size="large"
                title="aggregatorAddEntityModal-termsTitle"
            />
        );
    }
}

AggregatorAddEntityNewModal.defaultProps = {
    showModal: true,
}

AggregatorAddEntityNewModal.propTypes = {
    showModal: PropTypes.bool,
    immAggregatorAddEntity: PropTypes.object,
    onHandleTermsAndConditionsButton: PropTypes.func,
    onRequestClose: PropTypes.func,
};

export { AggregatorAddEntityNewModal };
